import React from 'react';
import { useProfile } from './useProfile';
import ProfileCard from './ProfileCard';
import LoadingState from './LoadingState';
import ProfileStats from './ProfileStats';
import ProfileActivity from './ProfileActivity';
import ProfileBadges from './ProfileBadges';
import { styles } from './styles';

// User Icon for Header
const UserIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const Profile = () => {
  const { userData, loading, handleEditProfile } = useProfile();

  if (loading || !userData) {
    return <LoadingState />;
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerIcon}>
            <UserIcon />
          </div>
          <div>
            <h1 style={styles.title}>My Profile</h1>
            <p style={styles.subtitle}>
              View and manage your account information
            </p>
          </div>
        </div>

        {/* Main Content Grid */}
        <div style={styles.contentGrid}>
          {/* Left Column */}
          <div style={styles.leftColumn}>
            <ProfileCard 
              userData={userData}
              onEditProfile={handleEditProfile}
            />
            <ProfileBadges userData={userData} />
          </div>

          {/* Right Column */}
          <div style={styles.rightColumn}>
            <ProfileStats userData={userData} />
            <ProfileActivity userData={userData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;